// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"style__errorPage__7p1JO","body":"style__body__Ma+n6"};